export const mapping = [
    'date',
    'callNum1', 
    'callNum2', 
    'hungUpTime', 
    'callReceivedNum', 
    'bombLocation', 
    'bombDetonationdDate', 
    'bombDescription', 
    'bombType',
    'bombDetonationCause', 
    'placedBomb', 
    'whyPlacedBomb',
    'perpName', 
    'threat',
    'other',
    'callerLocation',
    'callerAge',
    'voice',
    'otherAboutCaller'
];

export const callerVoiceOptions1 = [
    'Accent', 
    'Angry', 
    'Calm', 
    'Clearning Throat', 
    'Coughing', 
    'Cracking Voice', 
    'Crying', 
    'Deep', 
    'Deep breating',
    'Disguised',
    'Distinct',
    'Excited',
    'Female',
    'Laughter',
];

export const callerVoiceOptions2 = [
    'Lisp',
    'Loud',
    'Male',
    'Nasal',
    'Normal',
    'Ragged',
    'Rapid',
    'Raspy',
    'Slow',
    'Slurred',
    'Soft',
    'Stutter'
];

export const backgroundSounds = [
    'Animal noises',
    'House noises',
    'Kitchen noises',
    'Street noises',
    'Booth',
    'PA System',
    'Conversation',
    'Music',
    'Motor',
    'Clear',
    'Static',
    'Office machinery',
    'Factory machinery',
    'Local',
    'Long distance'
];

export const threatLanguage = [
    'Incoherent',
    'Message Read',
    'Taped',
    'Irrational',
    'Profane',
    'Well spoken'
];